/**
 * PATH: packages/email-hub/src/feature/lib/labelFamily.ts
 * FILE_ID: EMAILHUB-FEATURE-LIB-LABELFAMILY-001
 * PURPOSE: Shared vocabulary for the distinct "label" concepts operators
 *          collapse into one word (Filing Integrity P4).
 * WHY: Org tags, personal categories, built-in categories, AI status
 *      glyphs, and CRM company chips must stay visually/aurally distinct.
 */
export type LabelFamily =
  | 'org_tag'
  | 'personal_category'
  | 'org_category'
  | 'builtin_category'
  | 'ai_status'
  | 'crm_company'
  | 'allocation'
  | 'home_org'

const TITLES: Record<LabelFamily, string> = {
  org_tag: 'Company tag — shared across this organisation',
  personal_category: 'Personal category — visible only to you',
  org_category: 'Organisation category — shared work label',
  builtin_category: 'Built-in category — platform vocabulary',
  ai_status: 'AI filing status — not an editable tag',
  crm_company: 'CRM company — sender identity',
  allocation: 'Kanban placement — board and lane',
  home_org: 'Email home organisation — allocate only within this org',
}

export function labelFamilyTitle(family: LabelFamily): string {
  return TITLES[family]
}
